// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3zVLJ","header":"MergedInvoice_header__2NRef"};